import React from 'react'
import Sidenav from '../Sidenav/Sidenav'
import SideNavLayout from '../Sidenav/SideNavLayout'
import { useNavigate } from 'react-router-dom';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

const Safetyhome = () => {
  const navigate = useNavigate();
  return (
      <SideNavLayout>
      <div className='flex text-center w-full flex-col justify-center'>
      <button onClick={() => navigate('/dashboard')} className='bg-[#145388] text-white justify-center py-1 flex w-[125px] items-center gap-1 rounded-md text-sm font-inter'>
            <HomeRoundedIcon style={{width:'18px'}}/> Back to Home
          </button>
            Safety Home 
      </div>
      </SideNavLayout>
  )
}

export default Safetyhome
